<template>
    <div class="self-evaluation-test-styles">
        <loading-anim :active="$store.state.loading" fullScreen></loading-anim>
        <audio id="music" ref="song" loop src="/static-appopensalud/audio/meditationSong.mp3"></audio>
            <!-- Pantalla inicial, mensaje de presentación del test -->
            <div class="test-container" v-if="initialPage">
                <b-row>
                    <h2>{{ testName }}</h2><br>
                </b-row>
                <b-row class="mb-md-4 mb-sm-2 m-auto">
                    <p v-html="$t(`tests.${testRoute}.description`)"></p>
                </b-row>
                <b-row>
                    <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="p-2 m-auto text-center">
                        <b-card class="neu-card">
                            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/pencil-icon-blue.svg" :height="iconSize" :width="iconSize" :color="BLUE_COLOUR" class="d-block mb-3"></base-icon>
                            <base-button @click="startTest">
                                <span> {{ $t('tests.startTest') }} </span>
                            </base-button>
                        </b-card>
                    </b-col>
                    <b-col xs="12" sm="12" md="6" lg="6" xl="6" class="p-2" v-if="canSeePastResults">
                        <b-card class="neu-card">
                            <base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/bars.svg" :height="iconSize" :width="iconSize" :color="BLUE_COLOUR" class="d-block mb-3"></base-icon>
                            <base-button @click="goToPastResults">
                                <span> {{ $t('tests.previousResults') }} </span>
                            </base-button>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            <!-- Bloque principal, incluye preguntas y parte superior que muestra el progreso -->
            <transition name="fade" mode="out-in">
            <div v-if="questionsPage" :key="$store.state.tests.currentSlide">
                <div class="test-container">
                    <div class="topDiv">
                        <div>
                            <span>{{ parseInt($store.state.tests.currentSlide * 100 / $store.state.tests.test.length) }}% {{ $t('tests.completed') }}</span>
                        </div>
                        <div class="float-right">
                            <button v-on:click="playPause" style="background-color: transparent; border: none;"><b-icon :icon="songPlaying ? 'volume-up-fill': 'volume-mute-fill'"></b-icon></button>
                        </div>
                    </div>
                    <b-progress class="testProgressBar" :value="$store.state.tests.currentSlide" :max="$store.state.tests.test.length" style="height:0.2rem"></b-progress>
                    <slot name="questions"></slot>
                </div>
                <transition name="fade" appear>
                    <wave-animation v-if="!resultsPage"></wave-animation>
                </transition>
            </div>            
            <div v-if="goResultsPage" class="slidesSize">
                <b-col xs="12" lg="8" class="px-0 pt-1 px-md-5 pt-md-2 m-auto text-center">
                    <h3><strong>{{$t('tests.congratulations')}} {{ $store.state.session.user.name }}</strong></h3><br>
                    <h4 v-html="$t('tests.testCompleted')"></h4><br>
                    <button type="submit" class="btn btn-primary" @click="showResults">
                        <span> {{ $t('tests.finishTest') }} </span>
                    </button>
                </b-col>
            </div>
            <div class="test-container" v-if="resultsPage" key="results">
                <slot name="results"></slot>
            </div>
            </transition>        
    </div>
</template>

<script>
import { BForm, BModal, BButton, BProgress } from 'bootstrap-vue'
import selfEvaluationTestMixin from '@/mixins/selfEvaluationTest.mixin'
import { TEST_PSYCHOSOCIAL_RISKS, TEST_WORK_ENVIRONMENT } from '@/constants/patientServices'
import PatientsRepository from '@/repositories/PatientsRepository'
import BaseButton from '@/components/base/buttons/BaseButton.vue'
import BaseIcon from '@/components/base/icons/BaseIcon.vue'
import WaveAnimation from '@/components/utils/WaveAnimation.vue'
import { BLUE_COLOUR } from '@/constants/colours'

export default {
    components: {
        BForm,
        BModal,
        BButton,
        BProgress,
        BaseButton,
        BaseIcon,
        WaveAnimation
    },
    mixins: [selfEvaluationTestMixin],
    props: {
        testName: {
            type: String,
            required: true
        },
        testId: {
            type: String,
            required: true
        },
        test: {
            type: Array,
            required: true
        },
        opposedAnswers: {
            type: Array,
            required: false
        },
        multidimensional: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            started: false,
            goResults: false,
            songPlaying: true,
            BLUE_COLOUR,
            iconSize: !this.$uiHelpers.isXlDevice ? '30' : '40'
        }
    },
    created () {
        this.$store.state.tests = {
            test: this.randomizeTest(),
            currentSlide: 0,
            completed: false,
            previousTestResults: [],
            DBResults: {}
        }
        this.getPreviousResults()
    },
    methods: {
        startTest () {
            this.started = true
            this.$refs.song.play()
        },
        showResults () {
            this.goResults = true
            this.$refs.song.pause()
        },
        playPause () {
            var s = this.$refs.song
            if (s.paused) {
                s.play()
                this.songPlaying = true
            } else {
                s.pause()
                this.songPlaying = false
            }
        },
        async getPreviousResults () {
            const patientId = this.$store.getters['session/userIsProfessional'] ? this.$route.params.patientId : null
            PatientsRepository.getPreviousMonthsResults(this.testId, patientId).then((response) => {
                this.checkTestAlreadyCompletedThisMonth(response.data)
                if ((this.$store.getters['session/userIsProfessional'] && !this.$store.state.tests.completed)) {
                    if (response.data.length) {
                        this.$store.commit('tests/setTestCompletedThisMonth', response.data[response.data.length - 1])
                        this.goResults = true
                        this.testResultsInfo(this.testId)
                    } else {
                        this.$router.push(`/error/unauthorized?returnUrl=${encodeURIComponent(window.location.href)}`)
                    }
                }
                this.$store.commit('tests/setPreviousTestResults', response.data)
            })
        },
        checkTestAlreadyCompletedThisMonth (results) {
            var filteredTest = this.testId === TEST_WORK_ENVIRONMENT ? this.checkTestAlreadyCompletedPastXMonths(results, 4) : this.checkTestAlreadyCompletedPastXMonths(results)
            if (filteredTest.length !== 1) return
            if (this.$store.getters['session/userIsPatient'] && this.testId !== TEST_PSYCHOSOCIAL_RISKS && this.testId !== TEST_WORK_ENVIRONMENT) {
                this.$store.dispatch('showInfoAlert', {text: this.$t('tests.alreadyCompletedMessage')})
            }
            this.goResults = true
            this.$store.commit('tests/setTestCompletedThisMonth', filteredTest[0])
            this.$store.commit('tests/setPreviousTestResults', results)
            this.testResultsInfo(this.testId)
            this.$emit('setFinishedMessageResultsHidden')
        },
        goToPastResults () {
            var pastResults = this.$store.state.tests.previousTestResults
            this.goResults = true
            this.$store.commit('tests/setTestCompletedThisMonth', pastResults[pastResults.length - 1])
            this.testResultsInfo(this.testId)
        },
        checkTestAlreadyCompletedPastXMonths (results, monthsNumber = 1) {
            return results.filter(x => {
                const resultDate = new Date(x.date)

                const resultYear = resultDate.getFullYear()
                const resultMonth = resultDate.getMonth()

                const currentYear = this.date.getFullYear()
                const currentMonth = this.date.getMonth()

                const monthsDiff = (currentYear - resultYear) * 12 + (currentMonth - resultMonth)

                return monthsDiff >= 0 && monthsDiff < monthsNumber
            })
        }
    },
    computed: {
        canSeePastResults () {
            return this.$store.state.tests.previousTestResults.length && this.testId !== TEST_PSYCHOSOCIAL_RISKS && this.testId !== TEST_WORK_ENVIRONMENT
        },
        initialPage () {
            return !this.started && !this.$store.state.tests.completed && this.$store.getters['session/userIsPatient']
        },
        questionsPage () {
            return this.started && !this.$store.state.tests.completed
        },
        goResultsPage () {
            return !this.goResults && this.$store.state.tests.completed
        },
        resultsPage () {
            return this.goResults && this.$store.state.tests.completed
        }
    }
}
</script>

<style lang="scss">
    .self-evaluation-test-styles {
        .test-container {
            @include desktop {
                min-height: 60dvh;
            }

            @include desktop-xl {
                min-height: 70dvh;
            }
        }
        .slidesSize {
            width: 100%;
            position: relative;
            z-index: 1;
            padding-bottom: 7rem;
        }
        .topDiv {
            text-align: center;
            margin-bottom:0.2rem;
            @include mobile {
                margin-left: 1.5rem;
            }
        }
        .topDiv div{
            display: inline-block;
        }
        .testProgressBar {
            height: 0.2rem;
            margin-bottom: 7rem;
            @include mobile {
                margin-bottom: 3rem;
            }
        }
        .fade-enter-active,
        .fade-leave-active {
            transition: opacity 0.6s ease;
        }
        .fade-enter-from,
        .fade-leave-to {
            opacity: 0;
        }
        .neu-card {
            width: 100%;
            display: flex;
            h2{
                color: $black;
            }
            flex-direction: column;
            background-color: $white;
            border-radius: 23px !important;
            box-shadow: $custom-shadow;
            @include desktop {
                padding: 1rem 2rem;
            }
            @include desktop-sm {
                padding: 1rem 2rem;
            }
            @include tablets {
                padding: 1rem 2rem;
            }
            @include mobile {
                padding: 1rem 1rem;
                h2{
                font-size: 1.3rem;
                }
            }
            height: 100%;
            border: 0px !important;
            box-sizing: border-box;
            border-radius: 10px;
            text-align: center;
        }
        .neu-card.mean-result {
            margin: 1.5rem auto 1.5rem;
            background-color: $blue;
        }
        .mean-result .subtitle-card {
            color: $white
        }
        .results-container {
            text-align: center;
            @include mobile {
                margin-top: 1.5rem;
            }
        }
        .results-card {
            margin: 1rem auto 1rem;
            display: inline-block;
            @include mobile{
                margin: auto;
                margin-bottom: 1.5rem;
            }
        }
        .subtitle-card {
            color: $blue;
            font-weight: bold;
            font-size: 1.25rem;
            white-space: normal;
            @include mobile {
                font-size: 1rem;
                display: inline-block;
            }
        }
        .barChart{
            height: 200px;
            margin-bottom: 3rem;
            @include mobile {
                height: 130px;
            }
        }
        .donut {
            height: 15rem;
            box-sizing: border-box;
            margin-right: 2rem;
            @media only screen and (max-width: 1000px) {
                margin-right: 0;
                margin-top: 1rem;
            }
        }
        .p-white {
            color: $white;
            text-align: justify;
        }

        .highcharts-container {
            margin: 0 auto;
        }

        .collapsed .accordion-arrow-open,
        .not-collapsed .accordion-arrow-closed {
            display: none;
        }
        .inputAnswer {
            width: 14rem;
            margin: 1.5rem 0.5rem 0rem;
            @media only screen and (max-width: 768px) {
                width: 100%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/views/selfEvaluationTests/TestTemplate.vue